import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { getAllBets } from '../../redux/slice/openBet/openBetSlice';
import Helper from "../../helper";
import "./OpenBets.css"; // Make sure this CSS file is imported
import { useParams } from "react-router-dom";
import { useAuth } from "../AuthContext";

function RightSection() {
  const dispatch = useDispatch();
  const userInfo = Helper(); // get login user details
  const { betPlaced } = useAuth();
  const openbets = useSelector((state) => state.bets); // Access Redux state
  const { event_id } = useParams()
  const [betsData, setBetsData] = useState([]);


  // A single state to hold all bets for the table
  const [allOpenBets, setAllOpenBets] = useState([]);

  // This function to fetch data remains unchanged
  const getOpenBetsByEvent = async () => {
    dispatch(getAllBets({
      user_id: userInfo?._id,
    }));
  };

  // Fetch bets when the component mounts
  useEffect(() => {
    getOpenBetsByEvent();
  }, [betPlaced]);

  // This effect runs when the 'openbets' data from Redux changes
  useEffect(() => {
    // console.log('openBEts : ', openbets);
    if (openbets?.bets?.length > 0) {
      let openBetsData = [];
      if (event_id) {
        openBetsData = openbets?.bets?.filter(
          (item) => item.match_id == event_id
        );
      }
      setBetsData(openBetsData);
      // console.log('openBEts data : ', openBetsData);
    }
  }, [openbets, event_id]);

  return (
    <>
      <div className="open-bet hidden lg:block md:block mainscreen-right-container pl-2 top-[137px] mt-[11px] right-0 absolute" style={{ width: "21%" }}>
        <p className="bg-[#17afc6] p-[3px] shadow-[1px_1px_4px_gray] font-bold text-sm !my-0 !mx-0  mt-[11px]font-['Roboto_Condensed']">
          <span>Open Bets</span>
        </p>

        {/* The single table container */}
        <div className="table-container">
          <table className="custom-bet-table">
            <thead>
              <tr>
                <th>Event Name</th>
                <th>Market Type</th>
                <th>Stack</th>
                <th>Odd</th>
              </tr>
            </thead>
            <tbody>
              {betsData.length > 0 ? (
                betsData.map((bet) => (
                  <tr key={bet._id}> {/* Use a uni
                e key for each row */}
                    <td>{bet.event_name}</td>
                    <td>{bet.market_name}</td>
                    <td>{bet.stake}</td>
                    <td>{bet.price_val}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  {/* Display a message when there are no bets */}
                  <td colSpan="4" style={{ textAlign: 'center' }}>No Open Bets Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default RightSection;